<!-- <header class="header">
    <a tabindex="0" class="header__logo">
        <span class="icon-cisco"></span>
    </a>
    <div tabindex="0" class="header__title">
        <h1>Cisco Application Detectors</h1>    
    </div>
    <div class="header__navigation">
        <ul class="tab-group">
            <li tabindex="0" class="tab-group__tab">
                <a routerLink="/home" class="tab-group__link" class="link">Home</a>
            </li>
            <li tabindex="0" class="tab-group__tab">
                <a class="tab-group__link" routerLink="/relnotes" class="link">Release Notes</a>
            </li>
            <li tabindex="0" onclick="toggleDropdown()" class="tab-group__tab">
                <div id="dropdownContainer" class="dropdown">
                    <a class="tab-group__link">Support<span class="icon icon-chevron-down"></span></a>
                    <div class="dropdown__menu">
                        <a tabindex="0" class="dropdown__item"
                            href="https://software.cisco.com/download/home/286259687/type/286321931/release/VDB"
                            class="link">VDB Software Downloads</a>
                        <a tabindex="0" class="dropdown__item" href="Support.html" class="link">Application Detector
                            Support</a>
                        <a tabindex="0" class="dropdown__item" href="https://talosintelligence.com/"
                            class="link">Talos</a>
                    </div>
                </div>
            </li>
            <li tabindex="0" onclick="toggleDropdown1()" class="tab-group__tab">
                <div id="dropdownContainer1" class="dropdown">
                    <a class="tab-group__link">Documentation<span class="icon icon-chevron-down"></span></a>
                    <div class="dropdown__menu">
                        <a tabindex="0" class="dropdown__item"
                            href="https://www.cisco.com/c/en/us/td/docs/security/firepower/670/configuration/guide/fpmc-config-guide-v67/application_detection.html"
                            class="link">Application Detection</a>
                        <a tabindex="0" class="dropdown__item" href="https://snort.org/downloads#openappid"
                            class="link">OpenAppID</a>
                    </div>
                </div>
            </li>
        </ul>
    </div>
    <div class="header__toolbar">
        <a tabindex="0" class="header__icon">
            <span class="icon icon-help"></span>
        </a>
        <a tabindex="0" class="header__icon">
            <span class="icon icon-user"></span>
        </a>
    </div>
</header> -->
     <!--  <app-sidenav-header></app-sidenav-header>
  
        <router-outlet></router-outlet>--> 
    
<!--<div class="sidebar">
    <a class="active" href="#home">Home</a>
    <a href="#news">News</a>
    <a href="#contact">Contact</a>
    <a href="#about">About</a>
  </div>-->
  
 <!--
  <div class="sidebar" id="mySidebar" [style.width]="sidebarWidth">    
   
    <a href=""class="closebtn" (click)="closeNav()">&times;</a>
    <a class="active" href="#home">Home</a>
<a href="#news">News</a>
<a href="#contact">Contact</a>
<a href="#about">About</a>
  </div>

  
  <div id="main" [style.marginLeft]="mainContentWidth">
    <button class="openbtn" (click)="openNav()"> Open Sidebar</button>
    <router-outlet></router-outlet>
  </div>  -->

<!-- <app-home></app-home> -->

<div class="container-fluid g-0">
   <app-top-navbar (sideNavToggled)="sideNavStatus = $event;"  [InputInfoArray] = "inputInfo"></app-top-navbar> 
    <main> 
        <app-sidenav-header id="sidebarHeader" [sideNavStatus]="sideNavStatus" [ngClass]="{'app-side-nav-open':sideNavStatus}"></app-sidenav-header>
        <div class="display-area" [ngClass]="{'display-area-shrink':sideNavStatus}">
            <router-outlet (activate)="onRouterOutletActivate($event)" ></router-outlet> 
        </div>
    </main>
</div>
